import { getDeviceInfo } from "../../utils/deviceInfo.utils";

const _ACTION_PREFIX = "frontend/deviceInfo";
export const UPDATE = `${_ACTION_PREFIX}/UPDATE`;

export const triggerUpdate = () => ({
  type: UPDATE,
  payload: getDeviceInfo(),
  meta: {},
  error: undefined
});
